import type { ComponentProps, FC } from 'react'

export const ExclamationIcon: FC<ComponentProps<'svg'>> = (props) => (
  <svg
    width="140"
    height="140"
    viewBox="0 0 140 140"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      className="fill-danger-light dark:fill-danger-default dark:opacity-20"
      d="M69.6857 136.171C107.067 136.171 137.371 106.359 137.371 69.5853C137.371 32.8113 107.067 3 69.6857 3C32.3039 3 2 32.8113 2 69.5853C2 106.359 32.3039 136.171 69.6857 136.171Z"
    />
    <path
      d="M80.4627 35.9235C79.3743 34.1163 77.8372 32.6212 76.0005 31.5833C74.1639 30.5454 72.0901 30 69.9805 30C67.8709 30 65.7971 30.5454 63.9605 31.5833C62.1239 32.6212 60.5868 34.1163 59.4984 35.9235L25.7845 90.9867C24.654 92.8478 24.0387 94.9761 24.0018 97.1533C23.9648 99.3306 24.5076 101.478 25.5743 103.377C26.6411 105.275 28.1934 106.856 30.0723 107.956C31.9512 109.057 34.089 109.638 36.2666 109.641H103.694C105.872 109.638 108.01 109.057 109.889 107.956C111.768 106.856 113.32 105.275 114.387 103.377C115.453 101.478 115.996 99.3306 115.959 97.1533C115.922 94.9761 115.307 92.8478 114.177 90.9867L80.4627 35.9235Z"
      fill="#D73A49"
    />
    <path
      d="M69.9803 81.9127C69.1327 81.9016 68.323 81.56 67.7236 80.9606C67.1242 80.3612 66.7826 79.5515 66.7715 78.7039V59.451C66.7715 58.6 67.1096 57.7838 67.7113 57.182C68.3131 56.5803 69.1293 56.2422 69.9803 56.2422C70.8313 56.2422 71.6475 56.5803 72.2493 57.182C72.851 57.7838 73.1891 58.6 73.1891 59.451V78.7039C73.178 79.5515 72.8364 80.3612 72.237 80.9606C71.6376 81.56 70.8279 81.9016 69.9803 81.9127Z"
      fill="white"
    />
    <path
      d="M69.9815 93.6818C72.3444 93.6818 74.26 91.7663 74.26 89.4034C74.26 87.0405 72.3444 85.125 69.9815 85.125C67.6186 85.125 65.7031 87.0405 65.7031 89.4034C65.7031 91.7663 67.6186 93.6818 69.9815 93.6818Z"
      fill="white"
    />
  </svg>
)

ExclamationIcon.displayName = 'ExclamationIcon'
